// RETTERBOX theme.js — extends Dawn, never replaces
// Dawn's cart-drawer.js handles: open/close, data-cart-toggle, line item mutations.
// This file handles: cart:updated UI sync, toast, quickview, formatMoney helper.
(function () {
  'use strict';

  // ── Money formatter — uses the SHOP's currency/money format (not hardcoded €)
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || (window.Shopify && window.Shopify.moneyFormat) || '{{amount}}';
    function fmtDelim(number, precision, thousands, decimal) {
      precision = (precision === undefined) ? 2 : precision;
      thousands = (thousands === undefined) ? ',' : thousands;
      decimal = (decimal === undefined) ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = fmtDelim(cents, 2); break;
      case 'amount_no_decimals': value = fmtDelim(cents, 0); break;
      case 'amount_with_comma_separator': value = fmtDelim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmtDelim(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmtDelim(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmtDelim(cents, 2, "'", '.'); break;
      default: value = fmtDelim(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.RB_formatMoney = formatMoney;

  // ── Cart sync (shared utility) ─────────────────────────────────────
  async function syncCart() {
    try {
      const cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    } catch (e) {
      console.warn('RETTERBOX: cart sync failed', e);
    }
  }
  window.RB_syncCart = syncCart;

  // ── cart:updated listener ──────────────────────────────────────────
  // Updates count badges, totals, shipping progress — does NOT touch Dawn's cart drawer HTML
  document.addEventListener('cart:updated', function (e) {
    const cart = e.detail;
    if (!cart) return;

    // Count badges
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (el.hidden !== undefined) el.hidden = cart.item_count === 0;
    });

    // Totals
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });

    // Shipping progress fill bars + remaining text
    document.querySelectorAll('[data-ship-fill]').forEach(function (fill) {
      const threshold = parseInt(fill.dataset.threshold, 10) || 4900;
      const done = cart.total_price >= threshold;
      const pct = Math.min(100, Math.max(cart.total_price > 0 ? 2 : 0, Math.round((cart.total_price / threshold) * 100)));
      fill.style.width = pct + '%';
      fill.classList.toggle('rb-shipping-bar__fill--done', done);

      // Update the remaining text sibling
      const bar = fill.closest('.rb-shipping-bar');
      if (bar) {
        const msgEl = bar.querySelector('[data-shipping-msg]');
        const remainEl = bar.querySelector('[data-cart-remaining]');
        if (done) {
          if (msgEl) { msgEl.className = 'rb-shipping-bar__msg rb-shipping-bar__msg--done'; msgEl.innerHTML = '🎉 Du hast <strong>kostenlose Lieferung</strong> freigeschaltet!'; }
        } else {
          const remaining = threshold - cart.total_price;
          const euros = (remaining / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          if (msgEl) msgEl.className = 'rb-shipping-bar__msg';
          if (remainEl) remainEl.textContent = euros + ' €';
        }
      }
    });

    // Update checkout button total
    document.querySelectorAll('.rb-checkout-btn--full').forEach(function (btn) {
      // Find total text node and update it
      const totalText = formatMoney(cart.total_price);
      const svgEl = btn.querySelector('svg');
      if (svgEl) {
        // Keep SVG, update text after it
        const text = btn.childNodes[btn.childNodes.length - 1];
        if (text && text.nodeType === 3) {
          text.textContent = ' Zur Kasse — ' + totalText;
        }
      }
    });
  });

  // NOTE: the rb-drawer open/close is owned by cart-drawer.js (window.RB_openCart).
  // It listens for 'cart:open' itself — no relay needed here.

  // ── Toast ──────────────────────────────────────────────────────────
  document.addEventListener('toast:show', function (e) {
    var message = e.detail && e.detail.message ? e.detail.message : '';
    showToast(message);
  });

  function showToast(message) {
    const toast = document.getElementById('rb-toast');
    if (!toast) return;
    const span = document.getElementById('rb-toast-msg') || toast.querySelector('span');
    if (span) span.textContent = message;
    toast.removeAttribute('aria-hidden');
    toast.classList.add('is-visible');
    setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
    }, 3000);
  }
  window.RB_showToast = showToast;

  // ── QuickView ──────────────────────────────────────────────────────
  // Single source of truth for the modal lifecycle. Guard against rapid clicks
  // with a request token so a slow earlier fetch can't overwrite a newer one.
  var qvRequestToken = 0;

  function getQuickViewInner(modal) {
    var inner = document.getElementById('rb-quickview-inner');
    if (!inner) {
      // Recreate if a previous bug or external script removed it
      inner = document.createElement('div');
      inner.id = 'rb-quickview-inner';
      inner.className = 'rb-quickview-inner';
      modal.appendChild(inner);
    }
    return inner;
  }

  // ── Quick-view "virtual page view" ─────────────────────────────────
  // When the modal opens we reflect the product in the address bar via
  // history.pushState (no reload, no extra request → no performance cost), so
  // opening the popup behaves like a product page view for analytics. The URL
  // (and <title>) are restored when the modal closes; the browser Back button
  // closes the modal too.
  var qvUrlActive = false, qvPrevUrl = null, qvPrevTitle = null;
  function rbVirtualPageview(url, title, handle) {
    try {
      document.dispatchEvent(new CustomEvent('rb:virtual-pageview', { detail: { url: url, title: title, handle: handle } }));
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: 'virtual_page_view',
          page_location: url,
          page_path: (new URL(url, window.location.origin)).pathname,
          page_title: title,
          rb_source: 'quickview'
        });
      }
    } catch (err) {}
  }

  document.addEventListener('quickview:open', function (e) {
    var handle = e.detail && e.detail.handle;
    if (!handle) return;
    var preVariant = e.detail && e.detail.variant;
    const modal = document.getElementById('rb-quickview-modal');
    if (!modal) return;
    const inner = getQuickViewInner(modal);

    const token = ++qvRequestToken;
    inner.innerHTML = '<div style="padding:40px;text-align:center;color:var(--text-muted)">Wird geladen…</div>';
    modal.removeAttribute('aria-hidden');
    modal.classList.add('is-open');
    lockBodyScroll();

    // Reflect the product URL in the address bar (like a page view). Push once per
    // opened modal; switching products while open replaces (no history stacking).
    try {
      var prodUrl = '/products/' + handle;
      if (!qvUrlActive) {
        qvPrevUrl = window.location.href;
        qvPrevTitle = document.title;
        history.pushState({ rbQuickview: true }, '', prodUrl);
        qvUrlActive = true;
      } else {
        history.replaceState({ rbQuickview: true }, '', prodUrl);
      }
    } catch (err) {}

    var qvUrl = '/products/' + handle + '?view=quick-view';
    if (preVariant) qvUrl += '&variant=' + encodeURIComponent(preVariant);
    fetch(qvUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (token !== qvRequestToken) return; // a newer open superseded this one
        inner.innerHTML = html;
        inner.scrollTop = 0;
        // Update the document title to the product + fire the virtual page view
        var nameEl = inner.querySelector('.rb-modal__name');
        if (nameEl) { try { document.title = nameEl.textContent.trim() + ' – Retterbox'; } catch (err) {} }
        rbVirtualPageview(window.location.href, document.title, handle);
        loadRecommendations(inner, token);
        initProductFeed(inner, token);
      })
      .catch(function () {
        if (token !== qvRequestToken) return;
        inner.innerHTML = '<div style="padding:40px;text-align:center">Fehler beim Laden.</div>';
      });
  });

  // Fetch Shopify product recommendations (Product Recommendations + Section
  // Rendering API) and inject them into the quick-view [data-rb-recs] slots.
  function loadRecommendations(scope, token) {
    scope.querySelectorAll('[data-rb-recs]').forEach(function (slot) {
      var base = slot.getAttribute('data-url');
      var pid = slot.getAttribute('data-product-id');
      var intent = slot.getAttribute('data-intent') || 'related';
      if (!base || !pid) return;
      var url = base + '?section_id=rb-recommendations&product_id=' + encodeURIComponent(pid) +
        '&intent=' + encodeURIComponent(intent) + '&limit=10';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (token !== qvRequestToken) return; // modal moved on to another product
          slot.innerHTML = html.trim();
        })
        .catch(function () {});
    });
  }

  // "Load more on scroll" grid feed inside the quick-view. Pulls the next page of
  // catalog products via the Section Rendering API and appends 4-per-row.
  function initProductFeed(scope, token) {
    var grid = scope.querySelector('[data-rb-feed]');
    if (!grid) return;
    var root = grid.closest('.rb-modal');
    if (!root) return;
    var currentHandle = grid.getAttribute('data-current-handle');
    // Remove the currently viewed product from the initial page.
    grid.querySelectorAll('.rb-pcwrap[data-handle="' + currentHandle + '"]').forEach(function (c) { c.remove(); });
    var loading = false, done = false;
    function maybeLoad() {
      if (loading || done || token !== qvRequestToken) return;
      var s = grid.querySelector('[data-rb-feed-sentinel]');
      if (!s) { done = true; return; }
      if (root.scrollTop + root.clientHeight < root.scrollHeight - 400) return;
      loading = true;
      fetch('/collections/all?section_id=rb-product-feed&page=' + encodeURIComponent(s.getAttribute('data-next-page')))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (token !== qvRequestToken) { done = true; return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          tmp.querySelectorAll('.rb-pcwrap').forEach(function (c) {
            if (c.getAttribute('data-handle') !== currentHandle) grid.insertBefore(c, s);
          });
          var next = tmp.querySelector('[data-rb-feed-sentinel]');
          if (next) { s.setAttribute('data-next-page', next.getAttribute('data-next-page')); }
          else { s.remove(); done = true; }
          loading = false;
          maybeLoad(); // keep filling while still near the bottom
        })
        .catch(function () { loading = false; });
    }
    root.addEventListener('scroll', maybeLoad, { passive: true });
    maybeLoad();
  }

  // Robust scroll lock. `body { overflow:hidden }` fails here because
  // `html { overflow-x: clip }` stops that value propagating to the viewport,
  // and iOS Safari ignores it entirely. Pinning the body with position:fixed
  // locks every browser; we restore the scroll position on unlock.
  var qvScrollY = 0;
  function lockBodyScroll() {
    if (document.body.classList.contains('rb-quickview-open')) return;
    qvScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    const sb = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.position = 'fixed';
    document.body.style.top = -qvScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    if (sb > 0) document.body.style.paddingRight = sb + 'px';
    document.body.classList.add('rb-quickview-open');
  }
  function unlockBodyScroll() {
    if (!document.body.classList.contains('rb-quickview-open')) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    document.body.classList.remove('rb-quickview-open');
    window.scrollTo(0, qvScrollY);
  }

  // Close only the modal UI (no history changes) — used when the close was itself
  // triggered by a history change (Back button / popstate).
  function closeQuickViewUI() {
    const modal = document.getElementById('rb-quickview-modal');
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      // Invalidate any in-flight fetch and clear content after the close animation
      qvRequestToken++;
      const inner = document.getElementById('rb-quickview-inner');
      if (inner) setTimeout(function () {
        if (!modal.classList.contains('is-open')) inner.innerHTML = '';
      }, 360);
    }
    unlockBodyScroll();
    if (qvPrevTitle != null) { try { document.title = qvPrevTitle; } catch (err) {} qvPrevTitle = null; }
  }

  function closeQuickView() {
    // Revert the address bar first. If we pushed a history entry, go back (this
    // fires popstate, which closes the UI); otherwise restore the URL directly.
    if (qvUrlActive) {
      qvUrlActive = false;
      if (history.state && history.state.rbQuickview) { history.back(); return; }
      if (qvPrevUrl) { try { history.replaceState(null, '', qvPrevUrl); } catch (err) {} }
      qvPrevUrl = null;
    }
    closeQuickViewUI();
  }

  document.addEventListener('quickview:close', closeQuickView);

  // Browser Back/Forward out of the quick-view URL closes the modal.
  window.addEventListener('popstate', function (e) {
    const modal = document.getElementById('rb-quickview-modal');
    if (modal && modal.classList.contains('is-open') && (!e.state || !e.state.rbQuickview)) {
      qvUrlActive = false;
      qvPrevUrl = null;
      closeQuickViewUI();
    }
  });

  // ── Country / market selector modal ────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-country-open]')) {
      var m = document.getElementById('rb-country-modal');
      if (m) { m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    }
    if (e.target.closest('[data-country-close]')) {
      var m2 = document.getElementById('rb-country-modal');
      if (m2) { m2.classList.remove('open'); m2.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = document.getElementById('rb-country-modal');
      if (m && m.classList.contains('open')) { m.classList.remove('open'); document.body.style.overflow = ''; }
    }
  });

  // ── Mobile search overlay ──────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobsearch-open]')) {
      const ov = document.getElementById('rb-mobsearch');
      if (ov) { ov.classList.add('open'); const inp = ov.querySelector('[data-mobsearch-input]'); if (inp) inp.focus(); }
    }
    if (e.target.closest('[data-mobsearch-close]')) {
      const ov = document.getElementById('rb-mobsearch');
      if (ov) ov.classList.remove('open');
    }
  });

  // ── Mobile category drawer (category tree) ─────────────────────────
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-catmenu-open]')) {
      const dr = document.getElementById('rb-catdrawer');
      if (dr) { dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); document.body.classList.add('rb-catmenu-open'); }
    }
    if (e.target.closest('[data-catmenu-close]')) {
      const dr = document.getElementById('rb-catdrawer');
      if (dr) { dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); document.body.classList.remove('rb-catmenu-open'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      const dr = document.getElementById('rb-catdrawer');
      if (dr && dr.classList.contains('is-open')) { dr.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true'); document.body.classList.remove('rb-catmenu-open'); }
    }
  });

  // ── Predictive search (desktop dropdown + mobile overlay) ──────────
  // Event-delegated so it works for both the header search and the mobile
  // overlay regardless of when they enter the DOM.
  (function () {
    var cache = {};
    var timers = new WeakMap();

    function resultsFor(input) {
      var wrap = input.closest('[data-rb-search]');
      return wrap ? wrap.querySelector('[data-rb-search-results]') : null;
    }

    function run(input) {
      var results = resultsFor(input);
      if (!results) return;
      var q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      if (cache[q]) { results.innerHTML = cache[q]; results.hidden = false; return; }
      var url = '/search/suggest?q=' + encodeURIComponent(q)
        + '&section_id=predictive-search'
        + '&resources[type]=product,collection,query'
        + '&resources[limit]=6'
        + '&resources[options][unavailable_products]=last';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html.trim();
          var inner = tmp.querySelector('.shopify-section') || tmp;
          var content = (inner.innerHTML || html).trim();
          cache[q] = content;
          results.innerHTML = content;
          results.hidden = false;
        })
        .catch(function () { results.hidden = true; });
    }

    // Delegated input handler (debounced per input element)
    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-rb-search-input]');
      if (!input) return;
      clearTimeout(timers.get(input));
      var t = setTimeout(function () { run(input); }, 200);
      timers.set(input, t);
    });
    document.addEventListener('focusin', function (e) {
      var input = e.target.closest('[data-rb-search-input]');
      if (!input) return;
      if (input.value.trim().length >= 2) run(input);
    });

    // Close desktop dropdown on outside click (mobile overlay closes via its own button)
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.rb-header__search [data-rb-search-results]').forEach(function (res) {
        var wrap = res.closest('[data-rb-search]');
        if (wrap && !wrap.contains(e.target)) { res.hidden = true; }
      });
    });

    // Search result row → open the quick-view modal instead of navigating to a PDP.
    document.addEventListener('click', function (e) {
      var row = e.target.closest('.rb-search__row[data-quickview]');
      if (!row) return;
      var handle = row.getAttribute('data-handle');
      if (!handle) return;
      e.preventDefault();
      // Dismiss search UI
      var mob = document.getElementById('rb-mobsearch');
      if (mob) mob.classList.remove('open');
      document.querySelectorAll('[data-rb-search-results]').forEach(function (r) { r.hidden = true; });
      document.dispatchEvent(new CustomEvent('quickview:open', { detail: { handle: handle } }));
    });
  })();

  document.addEventListener('click', function (e) {
    // Close quickview: close button OR click on backdrop (rb-mback / modal overlay itself)
    if (e.target.closest('.rb-modal__close')) {
      closeQuickView();
      return;
    }
    // Click on .rb-mback outside the modal card
    if (e.target.classList.contains('rb-mback')) {
      closeQuickView();
      return;
    }
    // Click directly on the fixed backdrop container
    if (e.target.id === 'rb-quickview-modal') {
      closeQuickView();
      return;
    }
    // NOTE: the [data-quickview] open-trigger lives in product-card.js, which
    // guards against clicks on buttons/stepper/fav. Do NOT duplicate it here —
    // an unguarded copy would open the modal even when the add-to-cart button
    // (inside the clickable card) is pressed.
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // If the image lightbox is open, let it close first — don't nuke the whole modal.
    if (window.RB_lightboxOpen && window.RB_lightboxOpen()) return;
    closeQuickView();
  });

  // ── Nutrition image lightbox ───────────────────────────────────────
  // Injected quick-view HTML can't run inline <script>, so the zoom is wired
  // here via delegation. Uses a native <dialog> (top layer, sits above the
  // quick-view modal). Handles single images and lists of images.
  (function () {
    var dialog = null;
    function ensureDialog() {
      if (dialog) return dialog;
      dialog = document.createElement('dialog');
      dialog.id = 'rb-lightbox';
      dialog.innerHTML =
        '<button type="button" class="rb-lightbox__close" aria-label="Schließen">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button><img alt="">';
      document.body.appendChild(dialog);
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('.rb-lightbox__close')) dialog.close();
      });
      return dialog;
    }
    window.RB_lightboxOpen = function () { return !!(dialog && dialog.open); };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-zoom-src]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var d = ensureDialog();
      var img = d.querySelector('img');
      img.src = btn.getAttribute('data-zoom-src');
      img.alt = btn.getAttribute('aria-label') || '';
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    });
  })();

  // ── Accordion toggle (quick-view) ──────────────────────────────────
  document.addEventListener('click', function (e) {
    const head = e.target.closest('.rb-acc__head');
    if (!head) return;
    head.classList.toggle('rb-acc__head--open');
    const body = head.nextElementSibling;
    if (body && body.classList.contains('rb-acc__body')) {
      body.classList.toggle('open');
    }
  });

  // ── Initial cart sync on page load ────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    syncCart();
  });

})();

/* ── Sticky-follow sidebar ────────────────────────────────────────────
   The desktop category rail travels with the page as you scroll down and
   pins to the bottom once its end is reached (and mirrors this when you
   scroll back up, pinning below the header). Handles rails taller than the
   viewport; falls back to a plain top-pin on short rails. */
(function () {
  var side = document.querySelector('.rb-side--aside');
  if (!side) return;

  var GAP_TOP = 8;      // breathing room below the sticky header
  var GAP_BOTTOM = 20;  // breathing room above the page bottom
  var lastScroll = window.pageYOffset || 0;
  var topVal = null;
  var ticking = false;

  function headerH() {
    var h = document.querySelector('.rb-header');
    return h ? Math.ceil(h.getBoundingClientRect().height) : 130;
  }

  function apply() {
    ticking = false;
    if (window.innerWidth <= 1000) { side.style.top = ''; topVal = null; return; }

    var vh = window.innerHeight;
    var elH = side.offsetHeight;
    var maxTop = headerH() + GAP_TOP;          // scrolled up → pinned below header
    var minTop = vh - elH - GAP_BOTTOM;        // scrolled down → bottom pinned (negative if tall)

    // Rail fits the viewport → simple top pin.
    if (elH <= vh - maxTop - GAP_BOTTOM) {
      side.style.top = maxTop + 'px';
      topVal = maxTop;
      lastScroll = window.pageYOffset || 0;
      return;
    }

    var cur = window.pageYOffset || 0;
    var delta = cur - lastScroll;
    lastScroll = cur;
    if (topVal === null) topVal = maxTop;
    topVal -= delta;
    if (topVal > maxTop) topVal = maxTop;
    if (topVal < minTop) topVal = minTop;
    side.style.top = topVal + 'px';
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { topVal = null; apply(); });
  // Recompute when a category group expands/collapses (changes rail height).
  side.addEventListener('toggle', function () { topVal = null; apply(); }, true);
  window.addEventListener('load', function () { topVal = null; apply(); });
  apply();
})();
